import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import IncentiveStructure from "../../components/incentive-system/incentive-calculations/IncentiveStructure";
import "../../styles/incentive-system/pt-incentives.css";

const IncentiveCalculation = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user;

  return (
    <HelmetWrapper title="WTF: Trainer Incentives">
      <IncentiveStructure userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default IncentiveCalculation;
